<template>
    <el-dialog
        :visible="dedicatedInformationVisible"
        :show-close="true"
        center
        width="914px"
        class="start_modal"
        :before-close="handleClose">
        <div class="start_modal_title">
            选择专线信息
        </div>
        <div>
            <div class="start_modal_box clearfix">
                <div v-for="(item,index) in addressList" @click="selectRadio(item)" :key="index" class="start_modal_box_flex">
                    <el-radio class="start_modal_radio" :value="item.id" v-model="radio" :label="item.id"><span></span></el-radio>
                    <div class="start_modal_content" style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);padding: 20px 0px;width: 95%;background: #FFF;" >
                        <div style="font-size: 20px;border-bottom: 1px solid #cbcbcb;text-align: center;padding-bottom: 10px;">
                            <span>{{item.setcity}}</span>
                            <span><i style="transform: rotate(90deg)" class="el-icon-sort"></i></span>
                            <span>{{item.arrcity}}</span>
                          </div>
                          <div style="padding: 20px;padding-bottom: 0px;">

                                 <div style="font-size: 16px;font-weight: 700;margin-bottom: 20px;color: #303133;">专线信息</div>
                                  <div>
                                    <el-table border style="width: 100%"  :data="tableData" >
                                        <el-table-column label="承运公司 ">
                                           <template slot-scope="scope"><span>{{item.zname}}</span></template>
                                        </el-table-column>
                                        <el-table-column label="运输车型">
                                           <template slot-scope="scope"><span>{{item.cartype}}</span></template>
                                        </el-table-column>
                                        <el-table-column label="联系人">
                                           <template slot-scope="scope"><span>{{item.setname}}</span></template>
                                        </el-table-column>
                                         <el-table-column label="虚拟电话">
                                           <template slot-scope="scope"><span>{{item.fictitious_arrphone}}</span></template>
                                        </el-table-column>
                                        <el-table-column label="出发地址">
                                           <template slot-scope="scope"><span>{{item.setaddress}} </span></template>
                                        </el-table-column>
                                        <el-table-column label="到站地址 ">
                                           <template slot-scope="scope"><span>{{item.arraddress}}</span></template>
                                        </el-table-column>
                                      </el-table>
                                  </div>
                                    <!--  <el-table-column label="经营范围 ">
                                           <template slot-scope="scope"><span>{{item.scope}}</span></template>
                                        </el-table-column> -->
                          </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="start_modal_btn">
            <el-button type="primary" @click="selectAddress">确认选择</el-button>
        </div>
    </el-dialog>

</template>

<script>
export default {
    props:["startCallback"],
   data (){
       return {
           tabId:1,
           radio:'',
           addressList:[],
           loading:false,
           dedicatedInformationVisible:false,
            pageNumber:1,
            pageNumberInput:1,
            pageSize:10,
            total:0,
            lastPage:0,
            tableData: [{}]

       }
   },
   components: {

   },
   watch: {

   },
   computed: {

   },
   methods: {
     open(StartAddress,endAddress){
       this.dedicatedInformationVisible=true;
       // 手动输入页码后确定
      this.$get('ZxService',{province:StartAddress.province,city:StartAddress.city,province1:endAddress.province,city1:endAddress.city})
       .then(data => {
            this.addressList = data;
            if(data.length<=0){
              this.$message.error('暂无选择专线！');
               this.dedicatedInformationVisible=false;
            }
            this.$forceUpdate();//更新

       } , error => {
           this.$message.error(error);
           this.loading = false;
       });

        /* this.$get('ZxService',{province:StartAddress.province,city:StartAddress.city,province1:endAddress.province,city1:endAddress.city})
         .then(data => {
             this.addressList = data.data;
             this.total = data.total;
             this.lastPage = data.last_page;
             this.loading = false;
         }, error => {
             this.loading = false;
             this.$message.error(error);
         });; */

     },
       selectRadio(item){
           this.radio = item.id;
       },
       selectAddress(){
           let findIndex = _.findIndex(this.addressList , item => {
               return item.id == this.radio;
           });
        //    console.log(findIndex);
           if(findIndex != -1){
               this.startCallback(this.addressList[findIndex]);
                this.dedicatedInformationVisible=false;
            //    this.$emit('startCallback',);
           }else{
               this.$message.error('请选择专线！');
           }
       },
       handleClose(){
        this.dedicatedInformationVisible=false;
       },


       getAddressList(){
           this.addressList = [];
           this.loading = true;
           this.$get('Address',{type:this.tabId,page_index:this.pageNumber,page_size:this.pageSize})
            .then(data => {
                this.addressList = data.data;
                this.total = data.total;
                this.lastPage = data.last_page;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });;
       }
   },
   created() {
      // this.getAddressList();
   },
   mounted() {

   }
}
</script>

<style scoped lang='less'>
  .start_modal_content{
    width: 85%;
  }
.start_modal{

    /deep/ .el-dialog__header{
        display: none;
    }
    .start_modal_radio{
        // position: relative;
        top:12px;
    }
    /deep/ .el-radio{
        margin-right: 0;
    }
    .start_modal_box_flex{
        width:100%;
        display: inline-block;
        display: flex;
        align-items: center;
        flex-wrap:nowrap;
        cursor: pointer;
        margin-right: 20px;
        float: left;
    }
    .start_modal_box{
        width:880px;
    }
    &_content{
        padding: 20px;
        width:100%;
        margin-top: 20px;
        background: #F7F9FC;
        &_top{
            display: flex;
            justify-content:space-between;
            align-items: center;
            &_title{
                font-size: 18px;
                font-weight: 600;
                line-height: 18px;
            }
            &_action{
                display: flex;

                &_edit{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left:20px;
                    img{
                        width:20px;
                    }
                    span{
                        font-size: 16px;
                        color:#A6AEC1;
                    }
                }


            }
        }
        &_bottom{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top:16px;
            height: 40px;
            &_title{
                overflow: hidden;
                text-overflow: ellipsis;
                line-clamp: 2;
                span{
                    font-size: 14px;
                    color:#666666;
                    margin-right: 10px;
                }
            }
            &_action{
                /deep/ .el-radio__label{
                    color:#A6AEC1;
                }
                /deep/ .el-radio .el-radio__inner{
                    border-color:#A6AEC1;
                    background: transparent;
                }
                /deep/ .el-radio.is-checked .el-radio__inner{
                    background: #409EFF;
                    border-color: #DCDFE6;
                }
            }
        }
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        height: 28px;
        line-height: 28px;
        text-align: center;
    }
    &_btn{
        text-align:center;
        margin-top:40px;
        /deep/ .el-button{
            height: 36px;
            padding: 10px 16px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 400;
        }
    }
}

  .el-table{
            border-radius: 5px;
            border-top:1px solid #DEDEDE;
            border-left:1px solid #DEDEDE;
            border-bottom:1px solid #DEDEDE;
        }

 /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/dedicatedInformation.vue